/*
 * Desktop - PDP - 0 - 1500 BNPL Options  --  variant: Buy Now, Pay Later
 * Moonshot experiment id: 14228428   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-10-03
 * Audience: DESKTOP   Target: pdp_0_1500   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_d_bnpl_0_1500
 */
MGExp.run('pdp_d_bnpl_0_1500', { name: "Desktop - PDP - 0 - 1500 BNPL Options / Buy Now, Pay Later", platform: 'desktop', target: 'pdp_0_1500' }, function () {
  !(function () {
    let t = [".pdp-payment-options > .m-auto", ".pdp-payment-options > span"],
      e = [];
    async function i(i, a, s, n, p) {
      let o = {
        multi_target_selectors: t,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, a, s, n, p, o);
    }
    (i(
      ["div.pdp-payment-options"],
      ".msai-multi-css-marker",
      (t, e) => {
        e[0].classList.add("msai-multi-css-marker");
      },
      ".pdp-payment-options.msai-multi-payment-options-updated{flex-direction:column;align-items:normal}.msai-payment-text{font-size:14px;line-height:1.4;color:#000000;margin-top:8px;display:flex}.msai-payment-text a{text-decoration:underline;color:inherit}img.msai-inline{display:inline;margin:0 0 4px 0}.msai-pdp-dropdown-spacing{margin-top:5px}.pdp-payment-options > .m-auto,.pdp-payment-options > span{display:none}",
    ),
      i(
        ["div.pdp-payment-options", "#price"],
        ".msai-multi-payment-options-updated",
        function (t, e) {
          const [i, a] = e,
            s = i.querySelector("span#payment-options-btn");
          if (s) {
            const t = a.innerText,
              e =
                ((parseFloat(t.replace(/[^\d.-]/g, "")) / 4).toFixed(2),
                document.createElement("div"));
            ((e.className = "msai-payment-text"),
              (e.innerHTML =
                '<span class="msai-pdp-dropdown-spacing"> Buy Now, Pay Later</span><img class="m-auto" src="https://cdn.shopify.com/s/files/1/0133/9195/3977/files/pay-shop.png?v=1717438035" alt="shop"><img class="m-auto" src="https://cdn.shopify.com/s/files/1/0133/9195/3977/files/pay-afterpay.png?v=1717438034" alt="afterpay"><img class="m-auto" src="https://cdn.shopify.com/s/files/1/0133/9195/3977/files/pay-klarna.png?v=1717438034" alt="klarna"></div>'),
              s.parentNode.insertBefore(e, s));
          }
          let n = document.querySelector(".msai-affirm-trigger");
          if (n) {
            let t = document.querySelector(".affirm-modal-trigger");
            t &&
              (n.onclick = function () {
                t.click();
              });
          }
          i.classList.add("msai-multi-payment-options-updated");
        },
      ));
  })();
});
